module.exports = __webpack_public_path__ + "static/media/grand_mum_walk.c237c235.png";